import { render } from "./MessageInput.vue?vue&type=template&id=a1423a30&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"

import "./MessageInput.vue?vue&type=style&index=0&id=a1423a30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1423a30"]])

export default __exports__